"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxLabelStyled = exports.HiddenCheckboxStyled = exports.CheckboxStyled = exports.CheckboxContainerStyled = exports.SelectOptionsListStyled = exports.SelectStyled = exports.UploaderThumbnailStyled = exports.UploaderInputStyled = exports.UploaderDragStyled = exports.ContentVideoEmbebedStyled = exports.BBCodeEditorStyled = exports.BBCodeTextareaStyled = exports.BBCodeControlsStyled = exports.BBCodeButtonIconStyled = exports.TextareaStyled = exports.InputIconBoxStyled = exports.InputIconLeftStyled = exports.InputIconRightStyled = exports.InputBorderlesStyled = exports.InputStyled = exports.FormStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var _Icon = require("../Icon");

var _Typography = require("../Typography");

var InputsTextBoxSizes = {
  tiny: {
    fontSize: [2, 2, 1],
    lineHeight: [5, 5, 1],
    paddingX: [(3, 3, 3)],
    paddingY: [1, 1, 1]
  },
  small: {
    fontSize: [(2, 2, 2)],
    lineHeight: [5, 5, 5],
    paddingX: [(3, 3, 3)],
    paddingY: [1, 1, 1]
  },
  medium: {
    fontSize: [2, 2, 4],
    lineHeight: [5, 5, 5],
    paddingX: [4, 4, 4],
    paddingY: [3, 3, 3]
  },
  large: {
    fontSize: [2, 2, 4],
    lineHeight: [5, 5, 5],
    paddingX: [(4, 4, 4)],
    paddingY: [(3, 3, 4)]
  },
  huge: {
    fontSize: [4, 3, 4],
    lineHeight: [5, 5, 5],
    paddingX: [(5, 5, 5)],
    paddingY: [4, 4, 5]
  }
};
var CheckBoxSizes = {
  tiny: {
    fontSize: [2, 2, 1],
    lineHeight: [5, 5, 1],
    paddingX: [3],
    paddingY: [3],
    '&::after': {
      border: 'solid white',
      display: 'block',
      width: ['10px'],
      height: ['14px'],
      top: ['2px'],
      left: ['7px'],
      borderWidth: '0px 2px 2px 0px'
    }
  },
  small: {
    fontSize: [2],
    lineHeight: [5],
    paddingX: [3],
    paddingY: [3],
    '&::after': {
      border: 'solid white',
      width: ['10px'],
      height: ['14px'],
      top: ['2px'],
      left: ['7px'],
      borderWidth: '0px 2px 2px 0px'
    }
  },
  medium: {
    fontSize: [2, 2, 4],
    lineHeight: [5],
    paddingX: [4],
    paddingY: [4],
    '&::after': {
      border: 'solid white',
      width: ['13px'],
      height: ['20px'],
      top: ['2px'],
      left: ['9px'],
      borderWidth: '0px 3px 3px 0px'
    }
  },
  large: {
    fontSize: [4, 3, 4],
    lineHeight: [5],
    paddingX: [5],
    paddingY: [5],
    '&::after': {
      border: 'solid white',
      width: ['22px'],
      height: ['37px'],
      top: ['0px'],
      left: ['13px'],
      borderWidth: '0px 4px 4px 0px'
    }
  },
  huge: {
    fontSize: [4, 3, 4],
    lineHeight: [5],
    paddingX: [5],
    paddingY: [5],
    '&::after': {
      border: 'solid white',
      width: ['22px'],
      height: ['37px'],
      top: ['0px'],
      left: ['13px'],
      borderWidth: '0px 4px 4px 0px'
    }
  }
};
var CheckboxContainerSizes = {
  tiny: {
    height: ['24px']
  },
  small: {
    height: ['24px']
  },
  medium: {
    height: ['32px']
  },
  large: {
    height: ['48px']
  },
  huge: {
    height: ['48px']
  }
};
var InputsTextSizes = {
  tiny: {
    fontSize: [2, 2, 1],
    lineHeight: [5, 5, 1]
  },
  small: {
    fontSize: [(2, 2, 2)],
    lineHeight: [5, 5, 5]
  },
  medium: {
    fontSize: [2, 2, 4],
    lineHeight: [5, 5, 5]
  },
  large: {
    fontSize: [2, 2, 4],
    lineHeight: [5, 5, 5]
  },
  huge: {
    fontSize: [4, 3, 4],
    lineHeight: [5, 5, 5]
  }
};
var CheckboxLabelSeparators = {
  tiny: {
    top: [0, 0, 1],
    left: [5],
    paddingX: [3]
  },
  small: {
    left: [5],
    paddingX: [3]
  },
  medium: {
    left: [6],
    paddingX: [4],
    paddingY: [1]
  },
  large: {
    left: [7],
    paddingX: [5],
    paddingY: [3]
  },
  huge: {
    left: [7],
    paddingX: [5],
    paddingY: [3]
  }
};
var FormHasError = {
  true: {
    appearance: 'none',
    '-moz-box-shadow': 'borders.rambutan.complete',
    '-webkit-box-shadow': 'borders.rambutan.complete',
    boxShadow: 'borders.rambutan.complete',
    ':focus': {
      '-moz-box-shadow': 'borders.rambutan.complete',
      '-webkit-box-shadow': 'borders.rambutan.complete',
      boxShadow: 'borders.rambutan.complete'
    },
    ':hover': {
      '-moz-box-shadow': 'borders.rambutan.complete',
      '-webkit-box-shadow': 'borders.rambutan.complete',
      boxShadow: 'borders.rambutan.complete'
    }
  }
};

var FormStyled = _styledComponents.default.form.withConfig({
  displayName: "styles__FormStyled",
  componentId: "sc-7dgb4o-0"
})({
  width: '100%',
  position: 'relative'
}, _styledSystem.space, _styledSystem.color, _styledSystem.layout);

exports.FormStyled = FormStyled;
var InputStyled = (0, _styledComponents.default)('input').withConfig({
  displayName: "styles__InputStyled",
  componentId: "sc-7dgb4o-1"
})(_styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.textStyle, _styledSystem.shadow, _styledSystem.layout, (0, _css.default)({
  border: 'none',
  width: '100%',
  appearance: 'none',
  '-moz-box-shadow': 'borders.durian.complete',
  '-webkit-box-shadow': 'borders.durian.complete',
  boxShadow: 'borders.durian.complete',
  ':focus': {
    '-moz-box-shadow': 'borders.sonar.complete',
    '-webkit-box-shadow': 'borders.sonar.complete',
    boxShadow: 'borders.sonar.complete',
    '::placeholder': {
      color: 'white'
    }
  },
  ':hover': {
    '-moz-box-shadow': 'borders.guijarro.complete',
    '-webkit-box-shadow': 'borders.guijarro.complete',
    boxShadow: 'borders.guijarro.complete'
  },
  ':disabled': {
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  '::placeholder': {
    color: 'guijarro'
  }
}), (0, _styledSystem.variant)({
  prop: 'disabled',
  variants: {
    true: {
      backgroundColor: 'copoazu',
      color: 'ghosted.sonar.light',
      '::placeholder': {
        color: 'guama'
      }
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: InputsTextBoxSizes
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}));
exports.InputStyled = InputStyled;
var InputBorderlesStyled = (0, _styledComponents.default)('input').withConfig({
  displayName: "styles__InputBorderlesStyled",
  componentId: "sc-7dgb4o-2"
})(_styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.textStyle, _styledSystem.shadow, _styledSystem.layout, {
  border: 'none',
  width: '100%',
  backgroundColor: 'transparent',
  ':hover': {
    color: 'guijarro'
  },
  ':focus': {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
    borderColor: 'langsat',
    '::placeholder': {
      color: 'white'
    }
  },
  ':disabled': {
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  '::placeholder': {
    color: 'guijarro'
  }
}, (0, _styledSystem.variant)({
  prop: 'disabled',
  variants: {
    true: {
      color: 'ghosted.sonar.light',
      '::placeholder': {
        color: 'guama'
      }
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    small: {
      fontSize: [(2, 2, 2)],
      lineHeight: [5, 5, 5],
      paddingX: 0,
      paddingY: [1, 1, 1]
    },
    gigantic: {
      fontSize: [8, 7, 9],
      fontWeight: 'medium',
      lineHeight: [10, 9, 13],
      paddingX: 0,
      paddingY: [1, 1, 1]
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: {
    true: {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderStyle: 'dashed',
      borderColor: 'rambutan',
      ':focus': {
        borderWidth: 0,
        borderBottomWidth: 1,
        borderStyle: 'dashed',
        borderColor: 'rambutan'
      }
    }
  }
}));
exports.InputBorderlesStyled = InputBorderlesStyled;
var InputIconRightStyled = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "styles__InputIconRightStyled",
  componentId: "sc-7dgb4o-3"
})((0, _styledSystem.variant)({
  prop: 'space',
  variants: {
    tiny: {
      right: [3, 3, 3]
    },
    small: {
      right: [3, 3, 3]
    },
    medium: {
      right: [3, 3, 3]
    },
    large: {
      right: [(3, 3, 4)]
    },
    huge: {
      right: [4, 4, 5]
    }
  }
}));
exports.InputIconRightStyled = InputIconRightStyled;
var InputIconLeftStyled = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "styles__InputIconLeftStyled",
  componentId: "sc-7dgb4o-4"
})((0, _styledSystem.variant)({
  prop: 'space',
  variants: {
    tiny: {
      left: [3, 3, 3]
    },
    small: {
      left: [3, 3, 3]
    },
    medium: {
      left: [3, 3, 3]
    },
    large: {
      left: [(3, 3, 4)]
    },
    huge: {
      left: [4, 4, 5]
    }
  }
}));
exports.InputIconLeftStyled = InputIconLeftStyled;
var InputIconBoxStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__InputIconBoxStyled",
  componentId: "sc-7dgb4o-5"
})((0, _css.default)({
  appearance: 'none',
  '-moz-box-shadow': 'borders.durian.complete',
  '-webkit-box-shadow': 'borders.durian.complete',
  boxShadow: 'borders.durian.complete',
  ':focus': {
    '-moz-box-shadow': 'borders.sonar.complete',
    '-webkit-box-shadow': 'borders.sonar.complete',
    boxShadow: 'borders.sonar.complete',
    '::placeholder': {
      color: 'white'
    }
  },
  ':hover': {
    '-moz-box-shadow': 'borders.guijarro.complete',
    '-webkit-box-shadow': 'borders.guijarro.complete',
    boxShadow: 'borders.guijarro.complete'
  },
  ':disabled': {
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  '::placeholder': {
    color: 'guijarro'
  }
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}));
exports.InputIconBoxStyled = InputIconBoxStyled;
var TextareaStyled = (0, _styledComponents.default)('textarea').withConfig({
  displayName: "styles__TextareaStyled",
  componentId: "sc-7dgb4o-6"
})(_styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.textStyle, _styledSystem.shadow, _styledSystem.layout, (0, _css.default)({
  border: 'none',
  width: '100%',
  minHeight: '182px',
  resize: 'none',
  appearance: 'none',
  '-moz-box-shadow': 'borders.durian.complete',
  '-webkit-box-shadow': 'borders.durian.complete',
  boxShadow: 'borders.durian.complete',
  ':focus': {
    '-moz-box-shadow': 'borders.sonar.complete',
    '-webkit-box-shadow': 'borders.sonar.complete',
    boxShadow: 'borders.sonar.complete'
  },
  ':hover': {
    '-moz-box-shadow': 'borders.guijarro.complete',
    '-webkit-box-shadow': 'borders.guijarro.complete',
    boxShadow: 'borders.guijarro.complete'
  },
  '::placeholder': {
    color: 'guijarro'
  },
  '&:disabled': {
    cursor: 'not-allowed',
    boxShadow: 'none'
  }
}), (0, _styledSystem.variant)({
  prop: 'disabled',
  true: {
    backgroundColor: 'ghosted.copoazu.light',
    color: 'guijarro',
    '::placeholder': {
      color: 'guama'
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}));
exports.TextareaStyled = TextareaStyled;
var BBCodeButtonIconStyled = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "styles__BBCodeButtonIconStyled",
  componentId: "sc-7dgb4o-7"
})({
  cursor: 'pointer',
  display: 'inline-block'
});
exports.BBCodeButtonIconStyled = BBCodeButtonIconStyled;
var BBCodeControlsStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__BBCodeControlsStyled",
  componentId: "sc-7dgb4o-8"
})({
  userSelect: 'none'
});
exports.BBCodeControlsStyled = BBCodeControlsStyled;
var BBCodeTextareaStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__BBCodeTextareaStyled",
  componentId: "sc-7dgb4o-9"
})((0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}));
exports.BBCodeTextareaStyled = BBCodeTextareaStyled;
var BBCodeEditorStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__BBCodeEditorStyled",
  componentId: "sc-7dgb4o-10"
})(_styledSystem.typography, {
  cursor: 'text'
});
exports.BBCodeEditorStyled = BBCodeEditorStyled;
var ContentVideoEmbebedStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__ContentVideoEmbebedStyled",
  componentId: "sc-7dgb4o-11"
})({
  '> iframe': {
    width: '100%'
  }
});
exports.ContentVideoEmbebedStyled = ContentVideoEmbebedStyled;
var UploaderDragStyled = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "styles__UploaderDragStyled",
  componentId: "sc-7dgb4o-12"
})((0, _css.default)({
  '&:hover': {
    backgroundColor: 'copoazu'
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    large: {
      padding: 8
    },
    small: {
      padding: 6
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}));
exports.UploaderDragStyled = UploaderDragStyled;

var UploaderInputStyled = _styledComponents.default.input.withConfig({
  displayName: "styles__UploaderInputStyled",
  componentId: "sc-7dgb4o-13"
})({
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  position: 'absolute'
});

exports.UploaderInputStyled = UploaderInputStyled;
var UploaderThumbnailStyled = (0, _styledComponents.default)('canvas').withConfig({
  displayName: "styles__UploaderThumbnailStyled",
  componentId: "sc-7dgb4o-14"
})({
  width: '100%',
  height: '100%',
  position: 'absolute',
  objectFit: 'cover',
  filter: 'blur(1rem)',
  top: 0,
  left: 0,
  objectPosition: 'center center'
});
exports.UploaderThumbnailStyled = UploaderThumbnailStyled;
var SelectStyled = (0, _styledComponents.default)(InputStyled).withConfig({
  displayName: "styles__SelectStyled",
  componentId: "sc-7dgb4o-15"
})({
  zIndex: 1,
  appearance: 'none',
  outline: 0,
  position: 'absolute',
  backgroundImage: 'none',
  cursor: 'pointer',
  background: '#ffffff',
  '::-ms-expand': {
    display: 'none'
  }
}, (0, _styledSystem.variant)({
  props: 'size',
  variants: InputsTextBoxSizes
}));
exports.SelectStyled = SelectStyled;
var SelectOptionsListStyled = (0, _styledComponents.default)(_Typography.TextForm).withConfig({
  displayName: "styles__SelectOptionsListStyled",
  componentId: "sc-7dgb4o-16"
})({
  cursor: 'pointer'
}, _styledSystem.flexbox, (0, _styledSystem.variant)({
  prop: 'size',
  variants: InputsTextSizes
}), (0, _css.default)({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  '&:hover': {
    color: 'sonar'
  }
}));
exports.SelectOptionsListStyled = SelectOptionsListStyled;
var CheckboxContainerStyled = (0, _styledComponents.default)('label').withConfig({
  displayName: "styles__CheckboxContainerStyled",
  componentId: "sc-7dgb4o-17"
})(_styledSystem.space, (0, _css.default)({
  display: 'block',
  cursor: 'pointer',
  '-webkit-user-select': 'none',
  '-moz-user-select': 'none',
  '-ms-user-select': 'none',
  userSelect: 'none',
  ':focus': {
    outline: 'none'
  },
  ':active': {
    outline: 'none'
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: CheckboxContainerSizes
}));
exports.CheckboxContainerStyled = CheckboxContainerStyled;
var CheckboxStyled = (0, _styledComponents.default)(_styledComponents.default.span.withConfig({
  displayName: "styles__CheckboxStyled",
  componentId: "sc-7dgb4o-19"
})({
  position: 'absolute',
  top: '0',
  left: '0'
}, _styledSystem.border, _styledSystem.space, _styledSystem.color, _styledSystem.typography, _styledSystem.textStyle, _styledSystem.shadow, _styledSystem.layout, (0, _css.default)({
  border: 'none',
  '-moz-box-shadow': 'borders.durian.complete',
  '-webkit-box-shadow': 'borders.durian.complete',
  boxShadow: 'borders.durian.complete',
  ':focus': {
    outline: 'none',
    '-moz-box-shadow': 'borders.sonar.complete',
    '-webkit-box-shadow': 'borders.sonar.complete',
    boxShadow: 'borders.sonar.complete'
  },
  ':hover': {
    '-moz-box-shadow': 'borders.guijarro.complete',
    '-webkit-box-shadow': 'borders.guijarro.complete',
    boxShadow: 'borders.guijarro.complete'
  },
  ':disabled': {
    cursor: 'not-allowed',
    boxShadow: 'none'
  }
}), (0, _styledSystem.variant)({
  prop: 'checked',
  variants: {
    true: {
      backgroundColor: 'sonar',
      '-moz-box-shadow': 'borders.sonar.complete',
      '-webkit-box-shadow': 'borders.sonar.complete',
      boxShadow: 'borders.sonar.complete',
      ':hover': {
        '-moz-box-shadow': 'borders.sonar.complete',
        '-webkit-box-shadow': 'borders.sonar.complete',
        boxShadow: 'borders.sonar.complete'
      },
      '&::after': {
        display: 'block'
      }
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'disabled',
  variants: {
    true: {
      backgroundColor: 'copoazu'
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: CheckBoxSizes
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: FormHasError
}))).withConfig({
  displayName: "styles__CheckboxStyled",
  componentId: "sc-7dgb4o-18"
})(["&::after{content:'';position:absolute;color:", ";transform:rotate(39deg);}"], function (props) {
  return props.checked ? 'block' : 'none';
});
exports.CheckboxStyled = CheckboxStyled;

var HiddenCheckboxStyled = _styledComponents.default.input.withConfig({
  displayName: "styles__HiddenCheckboxStyled",
  componentId: "sc-7dgb4o-20"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;appearance:none;"]);

exports.HiddenCheckboxStyled = HiddenCheckboxStyled;
var CheckboxLabelStyled = (0, _styledComponents.default)(_Typography.TextForm).withConfig({
  displayName: "styles__CheckboxLabelStyled",
  componentId: "sc-7dgb4o-21"
})((0, _css.default)({
  position: 'absolute'
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    tiny: Object.assign(CheckboxLabelSeparators.tiny, InputsTextSizes.tiny),
    small: Object.assign(CheckboxLabelSeparators.small, InputsTextSizes.small),
    medium: Object.assign(CheckboxLabelSeparators.medium, InputsTextSizes.medium),
    large: Object.assign(CheckboxLabelSeparators.large, InputsTextSizes.large),
    huge: Object.assign(CheckboxLabelSeparators.huge, InputsTextSizes.huge)
  }
}), (0, _styledSystem.variant)({
  prop: 'hasError',
  variants: {
    true: {
      color: 'rambutan'
    }
  }
}));
exports.CheckboxLabelStyled = CheckboxLabelStyled;